export const RequestParams = {
  limit: 100,
  'order[user_sort]': 'asc',
}

export default {
  RequestParams,
}
